import React from 'react'
import PropTypes from 'prop-types'
import Image from '../components/Image/Image'
import Video from '../components/Video/Video'
import MediaTypeEnum from '../enums/MediaType'
import { getVideoUrl } from './getVideoUrl'
import { DEFAULT_ALT_IMAGE, DEFAULT_ALT_VIDEO } from '../constants/DefaultAlts'
import PlayButtonIcon from '../images/icons/play-button.svg'
import styled from 'styled-components'

const CLASSNAME = 'normalizedMedia'

const StyledThumbnailContainer = styled.div`
  position: relative;
  height: inherit;
`

const StyledOverlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #000000;
  opacity: 0.25;
  border-radius: 0 0 1.875rem 0;
`

const StyledPlayButtonIcon = styled(PlayButtonIcon)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -45%);
`

export default function NormalizeMedia(
  media,
  isMobile,
  withControls = true,
  hasThumbnail = false,
  isBanner = false
) {
  const poster =
    media?.cloudinaryPosterVideo?.[0]?.secure_url ||
    media?.contentfulPosterVideo?.file.url ||
    media?.videoThumbnail?.[0]?.secure_url ||
    null

  if (hasThumbnail && !isBanner) {
    return (
      <StyledThumbnailContainer>
        <StyledOverlay />
        <StyledPlayButtonIcon />
        <Image
          className={CLASSNAME}
          alt={
            media.altText?.altText ||
            media.cloudinaryAsset?.[0]?.context?.custom.alt ||
            media.name ||
            DEFAULT_ALT_IMAGE
          }
          isThumbnail
          absolutePath={poster}
        />
      </StyledThumbnailContainer>
    )
  }

  if (media?.youtubeUrl) {
    return (
      <iframe
        className={CLASSNAME}
        title={media.altText?.altText || DEFAULT_ALT_VIDEO}
        width="100%"
        height="100%"
        src={getVideoUrl(media.youtubeUrl)}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      >
        <img
          className={CLASSNAME}
          src={poster}
          alt={media.altText?.altText || media.name || DEFAULT_ALT_VIDEO}
          loading="lazy"
        />
      </iframe>
    )
  }
  if (media?.contentfulAsset) {
    if (media.contentfulAsset.gatsbyImageData) {
      return (
        <Image
          className={CLASSNAME}
          alt={media.altText?.altText || media.name || DEFAULT_ALT_IMAGE}
          absolutePath={
            media.contentfulAsset.gatsbyImageData.images.fallback?.src
          }
        />
      )
    } else {
      return (
        <Video
          key={media.contentfulAsset?.file?.url}
          className={CLASSNAME}
          alt={media.altText?.altText || media.name || DEFAULT_ALT_VIDEO}
          url={media.contentfulAsset?.file?.url}
          withControls={withControls}
          poster={poster}
        />
      )
    }
  }
  if (media?.cloudinaryAsset) {
    if (media.cloudinaryAsset[0].resource_type === MediaTypeEnum.video) {
      return (
        <Video
          key={media.cloudinaryAsset[0].secure_url}
          className={CLASSNAME}
          alt={
            media.altText?.altText ||
            media.cloudinaryAsset?.[0]?.context?.custom.alt ||
            media.name ||
            DEFAULT_ALT_VIDEO
          }
          url={media.cloudinaryAsset[0].secure_url}
          withControls={withControls}
          poster={poster}
        />
      )
    } else {
      return (
        <Image
          className={CLASSNAME}
          alt={
            media.altText?.altText ||
            media.cloudinaryAsset?.[0]?.context?.custom.alt ||
            media.name ||
            DEFAULT_ALT_IMAGE
          }
          absolutePath={media.cloudinaryAsset[0].secure_url}
        />
      )
    }
  } else {
    return null
  }
}

NormalizeMedia.propTypes = {
  data: PropTypes.object.isRequired,
}
